import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fb",
  "use": "icon-fb-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-fb\"><defs><style>#icon-fb .cls-1{fill:#409ae4;}</style></defs><title>de-icon-fb-blue</title><path class=\"cls-1\" d=\"M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm5.22,9.26H17.06c-.35,0-.75.42-.75,1.05v1.56h3.92v3.92H16.31v8.88H12.65V15.78H9.78V11.87h2.87V10.34c0-2.63,2-5,4.41-5h3.17Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol